import _ from 'lodash'
import { twMerge } from 'tailwind-merge'

type Props = {
  photo_url?: string | null
  name: string
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Avatar({ photo_url, className, name }: Props) {
  if (photo_url) {
    return (
      <img
        src={photo_url}
        className={twMerge('rounded-full', className)}
        alt={`Avatar: ${name}`}
      />
    )
  }

  className = twMerge(
    'inline-block overflow-hidden rounded-full bg-zinc-200 size-16 border border-zinc-200',
    'dark:bg-transparent dark:border-zinc-600',
    className,
  )

  return (
    <div className={className}>
      <svg fill='currentColor' viewBox='0 0 24 24' className='size-full text-white dark:text-zinc-600'>
        <path d='M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z' />
      </svg>
    </div>
  )
}

